export default {"src":"/_next/static/media/c11.f4843ec5.svg","height":75,"width":280};